import React, { useState } from "react";
import "./CardBody.css";
import card_image from "../../assets/card_image.jpg";

const CardBody = () => {
  const [activeCard, setActiveCard] = useState(2);

  const handleCardClick = (cardNumber) => {
    setActiveCard(cardNumber);
  };

  return (
    <div className="card-container">
      <div className={`card-body ${activeCard === 1 ? "active-card" : ""}`}>
        <img src={card_image} alt="Card 1" className="card-image" />
        <h1 className="card-title">Brisbane City</h1>
        <p className="card-description">
          Discover our range of top-tier automotive products, designed to keep
          your vehicle running smoothly. Get expert advice and quality service
          you can trust.
        </p>
        <div className="block"></div>
        <button className="card-button" onClick={() => handleCardClick(1)}>
          Button 1
        </button>
      </div>
      <div className={`card-body ${activeCard === 2 ? "active-card" : ""}`}>
        <img src={card_image} alt="Card 2" className="card-image" />
        <h1 className="card-title">Brisbane City</h1>
        <p className="card-description">
          Discover our range of top-tier automotive products, designed to keep
          your vehicle running smoothly. Get expert advice and quality service
          you can trust.
        </p>
        <div className="block"></div>
        <button className="card-button" onClick={() => handleCardClick(2)}>
          Button 2
        </button>
      </div>
      <div className={`card-body ${activeCard === 3 ? "active-card" : ""}`}>
        <img src={card_image} alt="Card 3" className="card-image" />
        <h1 className="card-title">Brisbane City</h1>
        <p className="card-description">
          Explore our in-depth automotive resources, covering everything from
          maintenance tips to the latest industry trends.
        </p>
        <br />
        <p className="card-description">
          We provide a comprehensive range of services, ensuring your vehicle
          remains in optimal condition year-round.
        </p>
        <button className="card-button" onClick={() => handleCardClick(3)}>
          Button 3
        </button>
      </div>
    </div>
  );
};

export default CardBody;
